var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFC224"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_39224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 10C13.582 10 10 13.582 10 17.9997C10 22.4174 13.582 26 17.9997 26C22.4174 26 26 22.4174 26 17.9997C26 13.582 22.4174 10 17.9997 10ZM19.665 22.3984C19.2532 22.5609 18.9255 22.6842 18.6796 22.7695C18.4345 22.8549 18.1493 22.8975 17.8249 22.8975C17.3265 22.8975 16.9384 22.7756 16.6621 22.5325C16.3858 22.2894 16.2483 21.9812 16.2483 21.6067C16.2483 21.4611 16.2585 21.3121 16.2788 21.1604C16.2998 21.0087 16.333 20.838 16.3783 20.6463L16.8937 18.8259C16.9391 18.6512 16.9784 18.4852 17.0095 18.3308C17.0407 18.1751 17.0556 18.0322 17.0556 17.9021C17.0556 17.6705 17.0075 17.508 16.912 17.4166C16.8152 17.3251 16.633 17.2804 16.3614 17.2804C16.2287 17.2804 16.0919 17.3001 15.9517 17.3414C15.8128 17.384 15.6923 17.4226 15.5934 17.4606L15.7295 16.8998C16.0668 16.7623 16.3898 16.6445 16.698 16.547C17.0061 16.4481 17.2974 16.3993 17.5716 16.3993C18.0667 16.3993 18.4487 16.5199 18.7175 16.7583C18.9851 16.9973 19.1198 17.3082 19.1198 17.6902C19.1198 17.7694 19.1103 17.9089 19.0921 18.108C19.0738 18.3078 19.0392 18.49 18.9891 18.6573L18.4764 20.4723C18.4345 20.6179 18.3972 20.7845 18.3633 20.9708C18.3302 21.157 18.3139 21.2992 18.3139 21.3947C18.3139 21.6358 18.3674 21.8004 18.4758 21.8877C18.5828 21.9751 18.7704 22.0191 19.0359 22.0191C19.1611 22.0191 19.3013 21.9968 19.4598 21.9534C19.6169 21.9101 19.7307 21.8715 19.8025 21.8383L19.665 22.3984ZM19.5743 15.0313C19.3352 15.2534 19.0474 15.3645 18.7108 15.3645C18.3749 15.3645 18.085 15.2534 17.8439 15.0313C17.6041 14.8091 17.4829 14.5389 17.4829 14.2233C17.4829 13.9084 17.6048 13.6375 17.8439 13.4133C18.085 13.1885 18.3749 13.0767 18.7108 13.0767C19.0474 13.0767 19.3359 13.1885 19.5743 13.4133C19.8133 13.6375 19.9332 13.9084 19.9332 14.2233C19.9332 14.5396 19.8133 14.8091 19.5743 15.0313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_39224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.9840ad6a0876f8be2b535eaa69e5b86e.svg";
export { ForwardRef as ReactComponent };